import styled from "styled-components";
import { getAnchorStyles } from "@website-builder/utilities/utils/DesignUtils.js";
import { TABLET_M_BP } from "@website-builder/utilities/constants/style-constants/screen-sizes.js";

export const CenteredContentWrapper = styled.div`
	padding: 80px 0;
	color: ${({ isDarkBackground }) =>
		isDarkBackground
			? "var(--primary-neutral-white)"
			: "var(--primary-neutral-nightshade-800)"};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	.topic-text {
		margin-bottom: 1rem;
	}
	.header-text {
		margin: 1rem 0 1.5rem 0;
	}
	.item-header {
		margin-bottom: 0.5rem;
	}
	.sub-header-text {
		margin: 0;
	}
	.description-text {
		margin: 0.5rem 0 0.5rem 0;
	}
	.list-header {
		margin: 0 0 1rem 0;
	}
	.logo-header {
		margin: 1.5rem 0 1.25rem;
		color: ${({ isDarkBackground }) =>
			isDarkBackground
				? "var(--primary-neutral-white)"
				: "var(--secondary-gray-dark)"};
	}
	ul {
		margin: 1rem 0 1.5rem;
		& li:last-child .item-description {
			margin-bottom: 1rem;
		}
	}
	.horizontal-list-container {
		align-items: center;
		& > div {
			justify-content: center;
		}
	}
	.horizontal-list-container .centered-content-logo {
		max-height: 50px;
	}
	.grid-container {
		gap: 0 24px;
	}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		padding: 40px 0px;
	}

	.rich-text-wrapper {
		${({ hasDarkBackground }) => getAnchorStyles(hasDarkBackground)}
	}
`;

export const ListItemWrapper = styled.div`
	text-align: start;
	.item-description {
		margin: 0;
	}
	.list-item {
		align-items: center;
	}
`;

export const LogoWrapper = styled.div`
	display: flex;
	align-items: center;
`;
